import _classCallCheck from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Shareable from '@shared/models/shareable';
import CalendarEvent from '@shared/models/calendar_event';

var BusySpanCalendarEvents = /*#__PURE__*/function (_Shareable) {
  _inherits(BusySpanCalendarEvents, _Shareable);

  var _super = _createSuper(BusySpanCalendarEvents);

  function BusySpanCalendarEvents() {
    var _this;

    _classCallCheck(this, BusySpanCalendarEvents);

    _this = _super.call(this);
    _this.bpCalendarEvents = new Map();
    return _this;
  }

  _createClass(BusySpanCalendarEvents, [{
    key: "set",
    value: function set(busySpanID, calendarEvent) {
      this.bpCalendarEvents.set(busySpanID, calendarEvent);
    }
  }, {
    key: "get",
    value: function get(busySpanID) {
      return this.bpCalendarEvents.get(busySpanID);
    }
  }, {
    key: "toPlainObject",
    value: function toPlainObject() {
      var plainObject = {};
      this.bpCalendarEvents.forEach(function (calendarEvent, busySpanID) {
        plainObject[busySpanID] = calendarEvent.toPlainObject();
      });
      return plainObject;
    }
  }], [{
    key: "fromPlainObject",
    value: function fromPlainObject(busySpanCalendarEvents) {
      var bpCalendarEvents = new this();
      Object.keys(busySpanCalendarEvents).forEach(function (busySpanID) {
        bpCalendarEvents.set(busySpanID, CalendarEvent.fromPlainObject(busySpanCalendarEvents[busySpanID]));
      });
      return bpCalendarEvents;
    }
  }]);

  return BusySpanCalendarEvents;
}(Shareable);

export { BusySpanCalendarEvents as default };